import {RcnPriceStatsUnit} from "../types/IRcnPriceStats";

const THOUSANDS_SEPARATOR = " ";
const percentFormatter = new Intl.NumberFormat("pl-PL", {minimumFractionDigits: 1, maximumFractionDigits: 1});
const signedPercentFormatter = new Intl.NumberFormat("pl-PL", {minimumFractionDigits: 1, maximumFractionDigits: 1, signDisplay: "exceptZero"});
const signedIntegerPercentFormatter = new Intl.NumberFormat("pl-PL", {maximumFractionDigits: 0, signDisplay: "exceptZero"});

const groupThousands = (value: number): string =>
    Math.round(Math.abs(value))
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, THOUSANDS_SEPARATOR);

export const formatPriceM2 = (value: number): string => `${value < 0 ? "-" : ""}${groupThousands(value)} zł/m²`;

// The transaction table can be read per square metre or as a whole-flat price, so the suffix has to follow
// the unit the figure was fetched with - a total price labelled "zł/m²" would be off by two orders.
export const formatPriceByUnit = (value: number, unit: RcnPriceStatsUnit): string =>
    unit === "total" ? `${value < 0 ? "-" : ""}${groupThousands(value)} zł` : formatPriceM2(value);

export const formatPercent = (value: number): string => `${percentFormatter.format(value)}%`;

export const formatSignedPercent = (value: number): string => `${signedPercentFormatter.format(value)}%`;

export const formatSignedIntegerPercent = (value: number): string => `${signedIntegerPercentFormatter.format(value)}%`;
import {RcnPriceStatsUnit} from "../types/IRcnPriceStats";

const THOUSANDS_SEPARATOR = " ";
const percentFormatter = new Intl.NumberFormat("pl-PL", {minimumFractionDigits: 1, maximumFractionDigits: 1});
const signedPercentFormatter = new Intl.NumberFormat("pl-PL", {minimumFractionDigits: 1, maximumFractionDigits: 1, signDisplay: "exceptZero"});
const signedIntegerPercentFormatter = new Intl.NumberFormat("pl-PL", {maximumFractionDigits: 0, signDisplay: "exceptZero"});

const groupThousands = (value: number): string =>
    Math.round(Math.abs(value))
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, THOUSANDS_SEPARATOR);

export const formatPriceM2 = (value: number): string => `${value < 0 ? "-" : ""}${groupThousands(value)} zł/m²`;

// The transaction table can be read per square metre or as a whole-flat price, so the suffix has to follow
// the unit the figure was fetched with - a total price labelled "zł/m²" would be off by two orders.
export const formatPriceByUnit = (value: number, unit: RcnPriceStatsUnit): string =>
    unit === "total" ? `${value < 0 ? "-" : ""}${groupThousands(value)} zł` : formatPriceM2(value);

export const formatPercent = (value: number): string => `${percentFormatter.format(value)}%`;

export const formatSignedPercent = (value: number): string => `${signedPercentFormatter.format(value)}%`;

export const formatSignedIntegerPercent = (value: number): string => `${signedIntegerPercentFormatter.format(value)}%`;
